<template>
  <div class="error-403">
    <div class="error-403__content">
      <h1>403</h1>
      <h2>Access Denied</h2>
      <p>
        Sorry, but you don't have permission to access this page.
        <br/>
        You can go  <router-link to="/admin/live-run">Back</router-link>
      </p>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Error403',
  data: () => ({
    env: process.env
  })
}
</script>

<style lang="stylus" scoped>
  .error-403
    min-height 100vh
    display flex
    flex-flow row wrap
    justify-content center
    align-items center

    &__content
      text-align center
      color #423799

      h1
        font-size 60px
        font-weight 700
        margin 0 0 15px

      h2
        font-size 50px
        font-weight 700
        margin 0 0 15px

      p
        font-size 14px
        color #423799 + 30%

        a
          color #423799
          font-weight 700
</style>



// WEBPACK FOOTER //
// 403.vue?51d6801a